import moment from 'moment'
import { apiSubTaskHandle } from '@/api/workPlace/retreatment'
import { nextTick } from 'vue'
import { REFRESH_LIST, REFRESH_MAIN } from '@/views/WorkPlace/handleEventBuss'

// 复诊提醒卡片角色展示
export const reVisitRolesCard = {
  DOCTOR: {
    role: '医生', // 角色文案
    buts: [
      {
        id: 'OUTOFCONTACT',
        title: '无法触达医生',
        disabled: item => false,
        operationBehavior: 10,
        handle: ({ item = {}, userInfo = {} }, cb) => {
          const data = {
            ...item,
            realName: userInfo.realName,
            operatorEnum: 2
          }
          subTaskReserveQuery(data, res => {
            cb(res)
          })
        }
      },
      {
        id: 'REDATE',
        // title: '批量修改复诊时间', // 按钮文案
        title: '修改复诊时间', // 按钮文案
        disabled: item => false,
        operationBehavior: 9,
        handle: (_, cb) => {
          // 按钮点击事件
          cb({
            type: 'dReDate'
          })
        }
      }, //按钮展示
      {
        id: 'ISKNOW',
        title: '确认医生已知晓',
        disabled: item => false,
        operationBehavior: 8,
        handle: ({ item = {}, userInfo = {} }, cb) => {
          const data = {
            ...item,
            realName: userInfo.realName,
            operatorEnum: 0,
            Mode_Content: '确认已于医生沟通，并且医生已知晓吗？' // 二次弹窗已不使用，这个字端和内容废弃
          }
          subTaskReserveQuery(data, res => {
            cb(res)
          })
        }
      }
    ]
  },
  PATIENT: {
    role: '患者',
    buts: [
      {
        id: 'OUTOFCONTACT',
        title: '无法触达患者',
        disabled: item => false,
        operationBehavior: 14,
        handle: ({ item = {}, userInfo = {} }, cb) => {
          const data = {
            ...item,
            realName: userInfo.realName,
            operatorEnum: 2
          }
          subTaskReserveQuery(data, res => {
            cb(res)
          })
        }
      },
      {
        id: 'REDATE',
        title: '修改复诊时间',
        disabled: item => false,
        operationBehavior: 12,
        handle: (_, cb) => {
          cb({
            type: 'pReDate'
          })
        }
      },
      {
        id: 'ISKNOW',
        title: '确认患者已知晓',
        disabled: item => false,
        operationBehavior: 11,
        handle: ({ item = {}, userInfo = {} }, cb) => {
          const data = {
            ...item,
            realName: userInfo.realName,
            operatorEnum: 0,
            Mode_Content: '确认已于患者沟通，并且患者已知晓吗？' // 二次弹窗已不使用，这个字端和内容废弃
          }
          subTaskReserveQuery(data, res => {
            cb(res)
          })
        }
      },
      {
        id: 'ISREVISIT',
        title: '确认患者已复诊',
        disabled: item => false,
        operationBehavior: 13,
        handle: ({ item = {}, userInfo = {} }, cb) => {
          const data = {
            ...item,
            realName: userInfo.realName,
            operatorEnum: 3
            // Mode_Content: '确认已于患者沟通，并且患者已知晓吗？' // 二次弹窗已不使用，这个字端和内容废弃
          }
          subTaskReserveQuery(data, res => {
            cb(res)
          })
        }
      }
    ]
  }
}
// 处理会话中和打开会话
export const handleList = {
  OPENSESSION: {
    title: '打开会话',
    handle: (item, store, emit) => {
      console.log('打开会话', item)
      // 调用一个接口 如果是医生就打开医生私聊否则就是三方群
      const groupId = item.role === 'DOCTOR' ? item.doctorGroupId : item.thirdGroupId
      // 创建一个新的群
      store.commit('workOrder/SET_CHART_ID', groupId)
      REFRESH_LIST?.emit()
      nextTick(() => {
        REFRESH_MAIN?.emit()
      })

      // 获取当前群组信息
      // getCurrentGroupInfo()
    },
    style: {
      color: '#1890FF'
    },
    titleStyle: {}
  },
  INCONVERSATION: {
    title: '会话中…',
    style: {
      color: '#24BCA2'
    },
    infoStyle: {
      color: '#24BCA2'
    },
    handle: item => {}
  }
}
// 设置展示是会话中还是打开会话
export const getOpenChatHandle = (item, chartId) => {
  // 如果当前为患者并且groupID===chartID就展示会话中，否则展示打开会话
  const currentChartId = item.role === 'DOCTOR' ? item.doctorGroupId : item.thirdGroupId
  if (chartId !== currentChartId) {
    return handleList.OPENSESSION
  } else {
    return handleList.INCONVERSATION
  }
}

// 医生/患者已知晓
export const subTaskReserveQuery = (data, cb) => {
  const params = {
    operatorEnum: data?.operatorEnum ?? 0,
    taskId: data.taskId,
    subTaskBusinessType: 'DA_CURE_RESERVE_ORDER',
    operatorName: data.realName,
    reserveEntry: 11,
    modifyReserveDateFlag: 1,
    hasQualityInspection: true, //质检场景下都传true，进行校验质检情况
    workOrderId: data.workOrderId
  }
  apiSubTaskHandle(params)
    .then(() => {
      cb()
    })
    .catch(() => {
      cb({ status: 'fail' })
    })
}

// 复诊类型
export const reVisitType = {
  1: '线上问诊',
  2: '门诊就诊'
}

// 判断上午或下午
export const getTimePeriod = reserveDate => {
  const momentDate = moment(reserveDate) // 创建moment对象
  const hour = momentDate.hour() // 获取小时数
  // 判断上午还是下午
  let period
  if (hour >= 0 && hour <= 12) {
    period = '上午'
  } else {
    period = '下午'
  }
  return period
}

// 根据当前会话中的进行排序,会话中的展示第一个
export const moveItemToFront = (array, chartId) => {
  // 查找具有指定id的元素的索引
  const index = array.findIndex(item => chartId === item.thirdGroupId)
  // 如果找到了该元素，并且它不在数组的首位
  if (index !== -1 && index !== 0) {
    // 使用解构赋值将该元素移到数组的开始
    const movedItem = array.splice(index, 1)[0] // 移除该元素
    array.unshift(movedItem) // 将该元素添加到数组的开始
  }
  return array
}

// 判断医生批量修改复诊日期是否展示
export const isShowBatchUpdate = (list = [], item = {}) => {
  const { role = '' } = item
  // 如果是患者就显示
  if (role === 'PATIENT') return true
  // // 判断子待办是否全部完成 找到子工单是否有未完成的子工单
  const res = list.filter(item => item.role === 'PATIENT').find(item => item.taskStatus !== 2)
  // 如果有未完成的就返true否则false
  return res ? true : false
}
